// The cars team's own axios instance.
//
// It carries the CARS token, never the superadmin one. Keeping them apart is
// the whole point: a car-team session must not inherit superadmin reach just
// because someone was signed in as superadmin in the same browser.

import axios from 'axios';
import { API_CONFIG, API_ENDPOINTS } from '../config/api.config';
import StorageUtil from '../utils/storage';
import { canHijackPath } from '../utils/authRealms';

let isRedirectingToLogin = false;

const carsAxiosInstance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

carsAxiosInstance.interceptors.request.use((config) => {
  // Login is the one call that must NOT carry a token — a stale one from a
  // previous session would be rejected before the credentials are even read.
  if (config.url?.includes(API_ENDPOINTS.CARS_TEAM.LOGIN)) return config;
  const token = StorageUtil.getCarsAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

carsAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const url = error.config?.url || '';
    const isAuthCall = url.includes(API_ENDPOINTS.CARS_TEAM.LOGIN)
      || url.includes(API_ENDPOINTS.CARS_TEAM.LOGOUT);
    // 403 counts here too: the cars endpoints answer 403 when the token
    // belongs to another actor, which for this app means "not signed in".
    if ([401, 403].includes(error.response?.status) && !isAuthCall) {
      StorageUtil.clearCarsAuth();
      // Only a tab showing /lot may be pulled to the cars login — the same
      // failure in a tab on another workspace clears the dead cars tokens
      // and leaves that tab's own session alone.
      if (!isRedirectingToLogin && canHijackPath('cars', window.location.pathname)) {
        isRedirectingToLogin = true;
        window.location.replace('/login?tab=cars&reason=session_expired');
      }
    }
    return Promise.reject(error);
  }
);

export default carsAxiosInstance;
